import {
  useIsAllowedPermission,
  type PermissionsRequestType,
} from '@mint-lib/profile-helpers';

import { IntegrationCategories } from '../constants/integrations.js';

const PERMISSION_MAPPINGS = {
  [IntegrationCategories.DSP]: 'dpsCostFeature',
  [IntegrationCategories.AD_SERVER]: 'adserverCostFeature',
  [IntegrationCategories.AGENCY]: 'agencyCostFeature',
} as const;
const useIntegrationsPermissions = (
  permissionType: 'view' | 'modify' | 'full_control',
  integrationCategory: string,
) => {
  const featurePrefix =
    integrationCategory in PERMISSION_MAPPINGS
      ? PERMISSION_MAPPINGS[
          integrationCategory as keyof typeof PERMISSION_MAPPINGS
        ]
      : PERMISSION_MAPPINGS[IntegrationCategories.DSP];

  const requestedAccess: PermissionsRequestType = `${featurePrefix}:${permissionType}`;
  const isAllowed = useIsAllowedPermission(requestedAccess);

  return integrationCategory in PERMISSION_MAPPINGS ? isAllowed : true;
};

export default useIntegrationsPermissions;
